import { Component, OnInit, ViewChild, ElementRef, TemplateRef} from '@angular/core';
import { GridOptions, GridApi, ColumnApi, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { PLANT_GROUP_DEFAULT_COL_DEF, PLANT_GROUP_COL_DEFS } from './plant-group.model';
import { PlantGroupService } from './plant-group.service';
import { IEntityPlantGroup } from 'projects/pplus/src/lib/interfaces/interfaces';
import { RowDataService } from 'projects/pplus/src/lib/components/split-form/services/row-data.service';
import { AgCheckboxComponent } from 'projects/pplus/src/lib/components/ag-grid/ag-checkbox/ag-checkbox.component';
import { AgBoolFilterComponent } from 'projects/pplus/src/lib/components/ag-grid/ag-bool-filter/ag-bool-filter.component';
import { AgBoolFloatingFilterComponent } from 'projects/pplus/src/lib/components/ag-grid/ag-bool-filter/ag-bool-floating-filter/ag-bool-floating-filter.component';
import { NbDialogService } from '@nebular/theme';
import { Observable, forkJoin } from 'rxjs';
import { DatePipe } from '@angular/common';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-plant-group',
  templateUrl: './plant-group.component.html',
  styleUrls: ['./plant-group.component.scss']
})
export class plantGroupComponent implements OnInit {
  @ViewChild('splitContent', { static: false}) splitContent;
  @ViewChild('agGrid', { read: ElementRef, static: false }) agGridNativeElement: ElementRef;
  @ViewChild('dialog', { read: TemplateRef, static: false }) dialogRef: TemplateRef<unknown>;

  splitOptions = {
    open: false,
    direction: 'horizontal',
    contentSize: 100,
    formSize: 0,
  };

  contextMenu = {
    X: 0,
    Y: 0,
    state: false,
  };

  row: IEntityPlantGroup = <IEntityPlantGroup>{};

  TitleForm = 'Detalles';
  gridApi: GridApi;
  gridColumnApi: ColumnApi;
  gridOptions: GridOptions = {
    defaultColDef: PLANT_GROUP_DEFAULT_COL_DEF,
    columnDefs: PLANT_GROUP_COL_DEFS,
    rowModelType: 'infinite',
    rowSelection: 'multiple',
    frameworkComponents: {
      checkboxComponent: AgCheckboxComponent,
      boolFilter: AgBoolFilterComponent,
      boolFloatingFilter: AgBoolFloatingFilterComponent,
    },
    floatingFilter: true,
    accentedSort: true,
  };

  private agDataSource: IDatasource = {
    rowCount: null,
    getRows: (rowParams: IGetRowsParams) => this.plantGroupService.getInfiniteScroll(
      rowParams.startRow, rowParams.endRow, rowParams.sortModel, rowParams.filterModel
    ).subscribe(res => rowParams.successCallback(this.processPlantGroupsFields(res.allPlantsGroups), res.lastRow))
  };

  constructor(
    private plantGroupService: PlantGroupService,
    private dataRow: RowDataService,
    private breakPointObserver: BreakpointObserver,
    private nbDialogService: NbDialogService,
    private adminService: AdminService,
  ) {}

  ngOnInit() {}

  private processPlantGroupsFields(plantGroups: IEntityPlantGroup[]): IEntityPlantGroup[] {
    for (const plantGroup of plantGroups) {
      const datePipe = new DatePipe('en-US');
      plantGroup.creationDate = datePipe.transform(plantGroup.creationDate, 'dd/MM/yyyy');
      plantGroup.deletionDate = datePipe.transform(plantGroup.deletionDate, 'dd/MM/yyyy');
      if (this.row && this.row.plantGroupId === plantGroup.plantGroupId) {
        this.row = <IEntityPlantGroup>JSON.parse(JSON.stringify(plantGroup));
        this.dataRow.updateRowData(this.row);
      }
    }
    return plantGroups;
  }

  onGridRowClicked(row) {
    this.row = <IEntityPlantGroup>JSON.parse(JSON.stringify(row.data));
    this.dataRow.updateRowData(this.row);
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    window.addEventListener('resize', function() {
      setTimeout(function() {
        params.api.sizeColumnsToFit();
      });
    });
    this.agGridNativeElement.nativeElement.addEventListener('contextmenu', function ($event: any) {
      $event.preventDefault();
    });
    this.gridOptions.api.setDatasource(this.agDataSource);
  }

  onCellContextMenu($event) {
    $event.event.preventDefault();
    const e = $event.event;

    let posx = 0;
    let posy = 0;

    if (e.pageX || e.pageY) {
      posx = e.pageX;
      posy = e.pageY;
    } else if (e.clientX || e.clientY) {
      posx = e.clientX + document.body.scrollLeft +
      document.documentElement.scrollLeft;
      posy = e.clientY + document.body.scrollTop +
      document.documentElement.scrollTop;
    }
    this.contextMenu = {
      X: posx,
      Y: posy,
      state: true
    };
  }

  rowDoubleClicked(event: any) {
    this.openSplit();
  }

  openSplit() {
    this.breakPointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(res => {
      if (res.matches) {
        this.splitOptions = {
          open: true,
          direction: 'horizontal',
          contentSize: 0,
          formSize: 100,
        };
      } else {
        this.splitOptions = {
          open: true,
          direction: 'horizontal',
          contentSize: 70,
          formSize: 30,
        };
      }
    });
  }

  readSplitOptions(event: any) {
    if (event.opt) this.splitOptions = event.opt;
  }

  updateData(isCreation: boolean) {
    if (isCreation) this.row = null;
    this.gridOptions.api.refreshInfiniteCache();
  }

  quickSearch(data: string) {
    if (this.gridApi) this.gridApi.setQuickFilter(data);
  }

  resizeGrid(event: any) {
    if (this.gridApi) this.gridApi.sizeColumnsToFit();
  }

  clearRow() {
    this.row = <IEntityPlantGroup>{};
    this.dataRow.updateRowData(this.row);
  }

  generalSearch(value: string) {
    if (value) this.gridOptions.api.setDatasource({
      rowCount: null,
      getRows: (rowParams: IGetRowsParams) => this.plantGroupService.getGeneralFilter(
        value, rowParams.startRow, rowParams.endRow, rowParams.sortModel, rowParams.filterModel
      ).subscribe(res => rowParams.successCallback(this.processPlantGroupsFields(res.allPlantsGroups), res.lastRow))
    });
    else this.gridOptions.api.setDatasource(this.agDataSource);
  }

  deleteSelected() {
    if (this.gridApi) {
      const selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows && selectedRows.length) this.nbDialogService.open(
        this.dialogRef, { context: 'Are you sure you want to delete all selected plant groups?' }
      ).onClose.subscribe(accepted => {
        if (accepted) {
          const deleteCalls: Observable<boolean>[] = [];
          for (const row of selectedRows) deleteCalls.push(this.plantGroupService.delete(row.plantGroupId));
          forkJoin(deleteCalls).subscribe(success => {
            if (success.every(b => b === true)) {
              this.adminService.showToast('success', 'All selected plant groups deleted');
            } else {
              this.adminService.showToast('danger', 'One or more plant groups couldn\'t be deleted');
            }
            this.clearRow();
            this.gridApi.refreshInfiniteCache();
            this.gridApi.deselectAll();
          });
        }
      });
    }
  }

}
